import { render, staticRenderFns } from "./record.vue?vue&type=template&id=2e4f0aaa"
import script from "./record.vue?vue&type=script&lang=ts"
export * from "./record.vue?vue&type=script&lang=ts"
import style0 from "./record.vue?vue&type=style&index=0&id=2e4f0aaa&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports